import Vue from 'vue'
const { DateTime } = require('luxon')
let checkVersionRequest = null

export default {
  getToken({ getters, dispatch, commit }, params) {
    return Vue.http.post(getters.endpoint.tokenAuth, params).then((response) => {
      const token = response.body['token']
      if (response.status == 200 || response.status == 201) {
        commit('updateToken', token)
        localStorage.setItem('token', token)

        //Сброс токена АСУ
        commit('updateAsuToken', '')
        localStorage.removeItem('asuToken')
      } else {
        console.log('authorization error')
        throw 'error'
      }
    })
  },
  logout({ commit, dispatch, getters }) {
    commit('updateToken', '')
    commit('updateAsuToken', '')
    commit('setActiveWorkspaceList', null)
    localStorage.removeItem('token')
    localStorage.removeItem('asuToken')
    dispatch('removeWorkspace')
    commit('setLastTimeVersionRequest', '')
    if (getters.versionRequestInterval) {
      clearInterval(getters.versionRequestInterval)
      commit('setVersionRequestInterval', null)
    }

    //Сброс данных пользователя
    commit('setPermissions', [])
    commit('setUserData', {
      userName: null,
      userId: null,
      userGroups: null,
      userDepartments: null,
      userAvailableVersions: null
    })
  },
  removeWorkspace({ commit }) {
    commit('setWorkspace', null)
    commit('setVersion', null)
    commit('setLastOpenedWorkspace', null)
    localStorage.removeItem('lastOpenedWorkspace')
  },
  getWorkspaces({ commit, dispatch, getters }) {
    return Vue.http
      .get(getters.endpoint.workspaces, {
        params: {
          limit: 20000
        }
      })
      .then((r) => {
        commit('setWorkspaceList', r.body.results)
      })
  },
  getActiveWorkspaces({ commit, dispatch, getters }) {
    return Vue.http.get(getters.endpoint.activeWorkspaces).then((r) => {
      commit('setActiveWorkspaceList', r.body)
    })
  },
  deleteWorkspace({ commit, dispatch, getters }, id) {
    return Vue.http.delete(getters.endpoint.workspace(id)).then((r) => {
      dispatch('getWorkspaces')
      dispatch('getActiveWorkspaces')
      if (getters.workspace === id) {
        dispatch('removeWorkspace')
        commit('setLastTimeVersionRequest', '')
        if (getters.versionRequestInterval) {
          clearInterval(getters.versionRequestInterval)
          commit('setVersionRequestInterval', null)
        }
      }
    })
  },

  editWorkspace({ dispatch, getters }, params) {
    return Vue.http.patch(getters.endpoint.workspace(params.id), params.fields).then((r) => {
      dispatch('updateWorkspace', r.body)
    })
  },
  updateWorkspace({ commit, dispatch, getters }, workspace) {
    const list = getters.workspaceList.concat([])
    const index = list.findIndex((v) => v.id === workspace.id)
    list[index] = workspace
    commit('setWorkspaceList', list)
    commit('setActiveWorkspaceList', list)
  },
  selectWorkspace({ commit, dispatch, getters }, workspaceId) {
    return Vue.http
      .get(getters.endpoint.workspaceVersion, {
        params: {
          limit: 1,
          is_active: 1,
          workspace: workspaceId
        }
      })
      .then((r) => {
        const activeVersion = r.body.results
        if (activeVersion.length > 0 && activeVersion[0].create_version_process !== getters.isVersionCopying) {
          commit('setIsVersionCopying', activeVersion[0].create_version_process)
        }
        if (activeVersion.length > 0 && activeVersion[0].create_workspace_process !== getters.isWorkspaceCopying) {
          commit('setIsWorkspaceCopying', activeVersion[0].create_workspace_process)
        }
        commit('setWorkspace', workspaceId)
        commit('setObjectsPeriod', null)
        commit('setVersionList', [])
        commit('setVersion', activeVersion.length > 0 ? activeVersion[0].version : 0)
        dispatch('setLastTimeVersionRequest')
        dispatch('getVersionList')
      })
  },
  getVersionList({ commit, dispatch, getters }) {
    return Vue.http
      .get(getters.endpoint.workspaceVersion, {
        params: {
          limit: 2000,
          workspace: getters.workspace
        }
      })
      .then((r) => {
        const list = r.body.results.map((v) => {
          let existed = getters.versionList.filter((version) => version.id === v.id)
          existed = existed.length > 0 ? existed[0] : null
          return {
            ...v,
            count: existed ? existed.count : -1,
            history: existed ? existed.history : []
          }
        })
        commit('setVersionList', list)
      })
  },
  checkVersion({ commit, dispatch, getters }) {
    if (!getters.workspace) {
      return Promise.resolve()
    }
    return Vue.http
      .get(getters.endpoint.workspaceVersion, {
        params: {
          limit: 1,
          is_active: 1,
          workspace: getters.workspace
        },
        before(request) {
          if (checkVersionRequest) {
            checkVersionRequest.abort()
          }
          checkVersionRequest = request
        }
      })
      .then((r) => {
        checkVersionRequest = null
        const activeVersion = r.body.results.filter((v) => v.is_active)
        if (activeVersion.length > 0) {
          if (activeVersion[0].create_version_process !== getters.isVersionCopying) {
            commit('setIsVersionCopying', activeVersion[0].create_version_process)
          }
          if (activeVersion[0].create_workspace_process !== getters.isWorkspaceCopying) {
            commit('setIsWorkspaceCopying', activeVersion[0].create_workspace_process)
          }

          if (getters.version !== activeVersion[0].version) {
            commit('setVersion', activeVersion[0].version)
            dispatch('getVersionList')
          }
        }
      })
      .catch((e) => {
        checkVersionRequest = null
      })
  },
  clearVersionHistory({ getters, commit }) {
    const list = getters.versionList
      .map((v) => {
        return {
          ...v,
          count: -1,
          history: []
        }
      })
      .concat([])
    commit('setVersionList', list)
  },
  setLastTimeVersionRequest({ commit, dispatch, getters }) {
    if (!getters.versionRequestInterval) {
      const interval = setInterval(() => {
        dispatch('getImmediateTimeVersion')
      }, 30000)
      commit('setVersionRequestInterval', interval)
    }
  },
  getImmediateTimeVersion({ commit, dispatch, getters }) {
    const d =
      getters.lastTimeVersionRequest ||
      DateTime.utc()
        .minus(30000)
        .toFormat('yyyy-LL-dd HH:mm:ss')
    Vue.http
      .get(getters.endpoint.versionRequest, {
        params: {
          date: d,
          workspace: getters.workspace
        }
      })
      .then((r) => {
        if (r.body && r.body.length > 0) {
          commit('setNewVersionExists', r.body)
          console.log('there are some changes in version: ', r.body)
        }
      })
    commit('setLastTimeVersionRequest', DateTime.utc().toFormat('yyyy-LL-dd HH:mm:ss'))
  },

  /**
   * Получение токена (авторизация в mw) по токену из системы АСУ
   * @param {*} param0
   * @param {Object} payload
   * @param {Object} payload.token токен из системы АСУ
   * @returns
   */
  getTokenByAsu({ getters, commit }, { asuToken }) {
    return Vue.http
      .post(getters.endpoint.tokenAsuAuth, {
        token: asuToken
      })
      .then((response) => {
        //Токен mw получен по токену АСУ
        const token = response.body['token']

        if (response.status == 200 || response.status == 201) {
          //Обновление токена mw в хранилище
          commit('updateToken', token)
          localStorage.setItem('token', token)

          //Обновление токена АСУ в хранилище
          commit('updateAsuToken', asuToken)
          localStorage.setItem('asuToken', asuToken)
        } else {
          console.log('authorization error')
        }
      })
  },

  loadUserData({ state, commit, getters }, { force = false } = {}) {
    let userDataPromise = state.userDataPromise

    if (force || !userDataPromise) {
      userDataPromise = Vue.http.get(getters.endpoint.me).then((response) => {
        commit('setPermissions', response.body.permissions)
        commit('setUserData', {
          userName: response.body.username,
          userId: response.body.id,
          userGroups: response.body.groups,
          userDepartments: response.body.departments,
          userAvailableVersions: response.body.available_versions
        })
      })

      commit('setUserDataPromise', userDataPromise)
    }

    return userDataPromise
  }
}



// WEBPACK FOOTER //
// ./src/store/auth/actions.js